export enum AcdEntityNameEnum {
    /* the duplicates have to be send through the api call, but can't be used as an id for the frontend selection
    * which is why the additional '_extra' was added
    * */
    ACD_ENTRANCE_VOICE = 'entrance',
    ACD_GROUP_NONVOICE = 'group',
    ACD_GROUP_SUMMARY = 'group_summary',
    ACD_GROUP_VOICE = 'group_extra',
    ACD_USER = 'user',
    ACD_USER_SUMMARY = 'user_summary',
    OBM_OVERVIEW = 'campaign',
    OBM_SUMMARY_OVERVIEW = 'campaign_summary',
    OBM_SUMMARY_USER_RANKING = 'campaign_summary_extra',
    OBM_USER_RANKING = 'campaign_extra',
}
